export enum OperationType {
  Saturation = 'saturation',
  Heatmap = 'heatmap',
  Walking = 'walking',
  Bicycle = 'bicycle',
  Motorcycle = 'motorcycle',
  Car = 'car',
  Orders = 'orders',
  Stores = 'stores'
}

export enum OperationTabType {
  Saturation,
  Operation,
  Stores
}
